import * as React from 'react';
import { BACKGROUND_COLOR, COLOR_A } from './CONSTANTS';
import { rgbToHsl } from './utilities.js';

const HSL = rgbToHsl(COLOR_A);



class Visualizer extends React.Component {
	constructor(props) {
		super(props);
		this.canvas = React.createRef();
	}

	componentDidUpdate() {
		this.draw();
	}

	draw() {
		const { audioData } = this.props;
		const canvas = this.canvas.current;
		const height = canvas.height;
		const width = canvas.width;
		const context = canvas.getContext('2d');
		let x = 0;
		let nBuckets = Math.floor(audioData.length / 4);
		const sliceWidth = (width / nBuckets) * 1.0;

		context.lineWidth = 0;
		context.strokeStyle = BACKGROUND_COLOR;
		context.clearRect(0, 0, width, height);

		context.beginPath();
		// context.moveTo(0, height);
		let lpItem = 255;

		let jump = 1.1;
		let offset = 0;

		const alpha = 0.1;

		audioData.slice(offset, nBuckets + offset).forEach((item, idx) => {
			lpItem = item * alpha + lpItem * (1 - alpha);
			// const y =alpha* (height-(item / 255.0) * height)+(1-alpha)*lastItem;

			let square = (lpItem * lpItem) / 255;

			context.fillStyle = 'hsl(' + HSL.h + ',' + (lpItem / 255) *HSL.s*100 + '%,' + (square / 255) * 100 + '%)';

			context.fillRect(width / 2 + x, height, sliceWidth, -height);
			context.fillRect(width / 2 - x, height, sliceWidth, -height);

			// context.fillRect(0,height/2+idx*height/(2*nBuckets),width,-height/(2*nBuckets));
			// context.fillRect(0,height/2-idx*height/(2*nBuckets),width,height/(2*nBuckets));

			x += sliceWidth;
		});
	}

	render() {
		return <canvas style={{ width: '100%', height: '100%' }} ref={this.canvas} />;
	}
}

export default Visualizer;
